var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _rect5, _rect6, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixedMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 78,
    viewBox: "0 0 93 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 53,
    height: 41,
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 29,
    width: 59,
    height: 45,
    fill: "#FF7628"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 41,
    width: 40,
    height: 27,
    fill: "#8DE4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 59,
    height: 8,
    fill: "#FF3D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.548 19.621C31.241 19.621 30.946 19.499 30.729 19.282L27.832 16.385C27.38 15.933 27.38 15.199 27.832 14.747C28.284 14.295 29.018 14.295 29.47 14.747L31.548 16.825L36.523 11.85C36.975 11.398 37.708 11.398 38.161 11.85C38.613 12.302 38.613 13.036 38.161 13.488L32.367 19.283C32.149 19.499 31.855 19.621 31.548 19.621Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.997 16.724H44.531C43.891 16.724 43.373 16.205 43.373 15.566C43.373 14.926 43.892 14.408 44.531 14.408H61.997C62.637 14.408 63.155 14.927 63.155 15.566C63.155 16.206 62.637 16.724 61.997 16.724Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 63L42.2583 72.75H19.7417L31 63Z",
    fill: "#00C013"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 61.6568C13.3067 60.772 14.6933 60.772 15.488 61.6568L23.128 70.1636C24.2843 71.4512 23.3705 73.5 21.64 73.5H6.36003C4.62948 73.5 3.71571 71.4512 4.87204 70.1636L12.512 61.6568Z",
    fill: "#00C013"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 52L42 62L31.5 72L21 62L31.5 52Z",
    fill: "#00C013"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 63,
    width: 12,
    height: 7,
    fill: "#00C013"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 62,
    width: 12,
    height: 12,
    fill: "#00C013"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.84 26.68H72.75V1.16C72.75 0.52 72.23 0 71.59 0H19.06C18.42 0 17.9 0.52 17.9 1.16V40.16H4.16C3.52 40.16 3 40.68 3 41.32V73.64C3 74.28 3.52 74.8 4.16 74.8H91.84C92.48 74.8 93 74.28 93 73.64V27.84C93 27.2 92.48 26.68 91.84 26.68ZM20.22 2.31H70.43V26.68H37.53L38.16 26.05C38.61 25.6 38.61 24.86 38.16 24.41C37.71 23.96 36.97 23.96 36.52 24.41L34.26 26.68H32.11C31.47 26.68 30.95 27.2 30.95 27.84V28.79L29.47 27.31C29.02 26.85 28.28 26.85 27.83 27.31C27.38 27.76 27.38 28.49 27.83 28.94L30.73 31.84C30.8 31.91 30.87 31.97 30.95 32.01V40.16H20.22V2.31ZM41.61 72.49H5.32V70.28L13.27 62.32L17.4 66.45C17.62 66.67 17.91 66.79 18.22 66.79C18.53 66.79 18.82 66.67 19.04 66.45L31.71 53.78L41.61 63.69V72.49ZM41.61 60.41L32.53 51.33C32.07 50.87 31.34 50.87 30.89 51.33L18.22 64L14.09 59.87C13.66 59.43 12.89 59.43 12.45 59.87L5.32 67V42.47H41.61V60.41ZM90.68 72.49H43.93V41.32C43.93 40.68 43.41 40.16 42.77 40.16H33.26V38.17H90.68V72.49ZM90.68 35.85H33.26V29H90.68V35.85Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.476 56.322C12.826 56.322 10.671 54.167 10.671 51.517C10.671 48.867 12.826 46.712 15.476 46.712C18.126 46.712 20.281 48.867 20.281 51.517C20.28 54.166 18.125 56.322 15.476 56.322ZM15.476 49.028C14.104 49.028 12.987 50.145 12.987 51.517C12.987 52.889 14.104 54.006 15.476 54.006C16.848 54.006 17.965 52.889 17.965 51.517C17.964 50.144 16.848 49.028 15.476 49.028Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 51.5,
    r: 3.5,
    fill: "#FFFF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51L68.1962 57H57.8038L63 51Z",
    fill: "#FFFF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60 55L61.7321 61H58.2679L60 55Z",
    fill: "#FFFF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53L63.7321 59H60.2679L62 53Z",
    fill: "#FFFF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 52L65.7321 58H62.2679L64 52Z",
    fill: "#FFFF00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49L62.5981 55H57.4019L60 49Z",
    fill: "#FFFF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.034 63.933C57.849 63.933 57.663 63.889 57.494 63.799C57.114 63.599 56.876 63.204 56.876 62.775V48.513C56.876 48.083 57.114 47.689 57.494 47.489C57.874 47.289 58.334 47.315 58.689 47.558L69.108 54.689C69.423 54.905 69.612 55.262 69.612 55.645C69.612 56.028 69.423 56.385 69.108 56.601L58.689 63.732C58.492 63.865 58.264 63.933 58.034 63.933ZM59.193 50.709V60.578L66.403 55.644L59.193 50.709Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.305 34.115C38.2389 34.115 38.996 33.3579 38.996 32.424C38.996 31.4901 38.2389 30.733 37.305 30.733C36.3711 30.733 35.614 31.4901 35.614 32.424C35.614 33.3579 36.3711 34.115 37.305 34.115Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.468 34.115C43.4019 34.115 44.159 33.3579 44.159 32.424C44.159 31.4901 43.4019 30.733 42.468 30.733C41.5341 30.733 40.777 31.4901 40.777 32.424C40.777 33.3579 41.5341 34.115 42.468 34.115Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.594 34.115C48.5279 34.115 49.285 33.3579 49.285 32.424C49.285 31.4901 48.5279 30.733 47.594 30.733C46.6601 30.733 45.903 31.4901 45.903 32.424C45.903 33.3579 46.6601 34.115 47.594 34.115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedMedia);
export default __webpack_public_path__ + "static/media/mixed_media.856c744024085e9f6dfd34e50bf6a11c.svg";
export { ForwardRef as ReactComponent };